import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCreate = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m22.987 30.894 16.508 45.294a3.833 3.833 0 0 1-2.287 4.914 3.833 3.833 0 0 1-4.913-2.29L15.787 33.518a3.833 3.833 0 0 1 2.287-4.914 3.833 3.833 0 0 1 4.913 2.29M53.731 25.984v48.212a3.833 3.833 0 0 1-3.834 3.832 3.833 3.833 0 0 1-3.832-3.832V25.984a3.833 3.833 0 0 1 3.832-3.832 3.833 3.833 0 0 1 3.834 3.832M84.001 33.31l-16.5 45.297a3.833 3.833 0 0 1-4.914 2.29 3.833 3.833 0 0 1-2.289-4.914l16.5-45.297a3.833 3.833 0 0 1 4.913-2.29A3.833 3.833 0 0 1 84 33.31" })
});
export default SvgCreate;
